import * as React from 'react';
import propz from 'propz';
import { Component } from 'react';
import { Form, Formik } from 'formik';
import { Switch } from 'Src/components/Switch/Switch';
import { Loader } from 'Src/components/Loader/Loader';
import { AppUser } from 'Src/views/App/App';
import { updateSchoolAdvancedSettings } from 'Src/helpers/service/admin/settings';
import { School } from 'Src/models/school';
import { SchoolSettingsTabs } from '../SchoolSettings/SchoolSettingsTabs';
import './SchoolSettingsAdvanced.scss';

interface Props {
  user: AppUser;
  onSchoolUpdate: () => Promise<School>;
}

interface State {
  isLoading: boolean;
}

const advancedSettings = [
  {
    title: 'Event photo uploads',
    description: 'Parents and students can upload photos to events they are part of.',
    field: 'photosEnabled'
  },
  {
    title: 'Event comments',
    description: 'Users can write comments on events where commenting is available.',
    field: 'commentsEnabled'
  }
];

export class SchoolSettingsAdvanced extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false
    };
  }

  onSubmit = values => {
    const { user } = this.props;

    this.setState({ isLoading: true });

    updateSchoolAdvancedSettings(user, values).then(() => {
      const { onSchoolUpdate } = this.props;

      return onSchoolUpdate().then(() => {
        this.setState({ isLoading: false });
      });
    });
  };

  renderSchoolSettingsAdvanced = (values, setFieldValue) => {
    return advancedSettings.map(setting => {
      const field = setting.field;
      const settingValue = propz.get(values, field.split('.'), false);

      return (
        <div className="schoolSettingsToggleRow" key={field}>
          <div className="schoolSettingsToggleRow__copy">
            <div className="schoolSettingsToggleRow__title">{setting.title}</div>
            <div className="schoolSettingsToggleRow__hint">{setting.description}</div>
          </div>
          <Switch
            value={settingValue}
            onChange={() => {
              const fieldValue = propz.get(values, field.split('.'), false);
              setFieldValue(field, !fieldValue);
            }}
            text={''}
            name={field}
          />
        </div>
      );
    });
  };

  render() {
    const { isLoading } = this.state;
    const { user } = this.props;

    const initialValues = {
      photosEnabled: propz.get(user, ['activeSchool', 'settings', 'photosEnabled'], false),
      commentsEnabled: propz.get(user, ['activeSchool', 'settings', 'commentsEnabled'], false)
    };

    if (isLoading) {
      return <Loader />;
    }

    return (
      <div className="schoolSettingsPage schoolSettingsAdvancedPage">
        <header className="schoolSettingsHeader">
          <h1>School settings</h1>
          <SchoolSettingsTabs />
        </header>

        <Formik initialValues={initialValues} onSubmit={values => this.onSubmit(values)}>
          {({ setFieldValue, handleSubmit, values, dirty, resetForm }) => {
            return (
              <Form>
                <section className="schoolSettingsCard schoolSettingsAdvancedCard">
                  <div className="schoolSettingsCard__header">
                    <div>
                      <h3>Moderation & participation</h3>
                      <p>Decide what parents and students can contribute across events and availability workflows.</p>
                    </div>
                  </div>
                  <div className="schoolSettingsToggleRows">
                    {this.renderSchoolSettingsAdvanced(values, setFieldValue)}
                  </div>
                </section>

                {dirty && (
                  <div className="schoolSettingsSaveBar">
                    <span className="schoolSettingsSaveBar__status">You have unsaved changes</span>
                    <div className="schoolSettingsSaveBar__actions">
                      <button type="button" className="schoolSettingsButton schoolSettingsButton--secondary" onClick={() => resetForm()}>
                        Discard
                      </button>
                      <button type="button" className="schoolSettingsButton schoolSettingsButton--primary" onClick={() => handleSubmit()}>
                        Save changes
                      </button>
                    </div>
                  </div>
                )}
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  }
}
